module.exports = __webpack_public_path__ + "img/Equal.0fd9aeae.svg";